export const CONFIRMED_CREATE_DISEASE_MEDICINE_MAPPING_ACTION = "CONFIRMED_CREATE_DISEASE_MEDICINE_MAPPING_ACTION";
export const CONFIRMED_DELETE_DISEASE_MEDICINE_MAPPING_ACTION = "CONFIRMED_DELETE_DISEASE_MEDICINE_MAPPING_ACTION";
export const CONFIRMED_EDIT_DISEASE_MEDICINE_MAPPING_ACTION = "CONFIRMED_EDIT_DISEASE_MEDICINE_MAPPING_ACTION";
export const CONFIRMED_GET_DISEASE_MEDICINE_MAPPINGS = "CONFIRMED_GET_DISEASE_MEDICINE_MAPPINGS";
